import { AuthState, OktaAuth } from '@okta/okta-auth-js';
import { PortalSessionMarker } from './portal-session-marker';

/**
 * Tokens are trusted only while they belong to the user of the portal session: a sign-out in Legacy
 * (marker removed) or a sign-in of another user (marker replaced) makes the Shell tokens orphaned.
 *
 * Plain functions (no DI) because they are also needed by the Okta configuration.
 */

export function ownsPortalSession(oktaAuth: OktaAuth): boolean {
  const userId = oktaAuth.tokenManager.getTokensSync().idToken?.claims.sub;
  return !!userId && userId === PortalSessionMarker.read();
}

/** Revokes the access token at Okta (best effort) and drops all local tokens. */
export async function discardTokens(oktaAuth: OktaAuth): Promise<void> {
  await oktaAuth.revokeAccessToken().catch(() => undefined);
  oktaAuth.tokenManager.clear();
}

/** `transformAuthState`: orphaned tokens never count as authenticated, so nothing is loaded for a signed-out user. */
export async function requireSessionOwnership(oktaAuth: OktaAuth, authState: AuthState): Promise<AuthState> {
  if (authState.isAuthenticated && !ownsPortalSession(oktaAuth)) {
    authState.isAuthenticated = false;
    void discardTokens(oktaAuth);
  }
  return authState;
}
